import stringsJson from './strings.json';
import touchStrings from './touchMDStrings.json';

//TODO: Get Product Switching setup
export const ProductStrings = touchStrings;
export const Strings = stringsJson;
